// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3OI39","loadingShrink":"PageLoading_loadingShrink__3XumA"};